// assets
import {
  IconKey,
  IconUserPlus,
  IconUser,
  IconClipboardText,
  IconDeviceAnalytics,
  IconAdjustments,
  IconCalculator,
} from "@tabler/icons";


const icons = { IconKey, IconUserPlus, IconUser };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const admin = {
  id: "credentialManagement",
  // title: "Credential Management",
  type: "group",
  group: [1, 2, 3, 4, 5],
  children: [
    {
      id: "itemAdmin",
      title: "Admin",
      type: "item",
      url: "admin",
      icon: IconClipboardText,
      breadcrumbs: false,
      group: [1],
    },
    {
      id: "itemMarkets",
      title: "Markets",
      type: "item",
      url: "markets",
      icon: IconDeviceAnalytics,
      breadcrumbs: false,
      group: [1, 2, 3, 4, 5],
    },
    {
      id: "optimizer",
      title: "Optimizer",
      type: "item",
      url: "optimizer",
      icon: IconAdjustments,
      breadcrumbs: false,
      group: [1, 2, 3, 4, 5],
    },
    // {
    //   id: "simulator",
    //   title: "Simulator",
    //   type: "item",
    //   url: "simulator",
    //   icon: IconCalculator,
    //   breadcrumbs: false,
    //   group: [1, 2, 3, 4, 5],
    // },
  ],
};

export default admin;
